import { IconCircleCheck, IconArrowRight } from '@tabler/icons-react'

const dataSourceItems = ['经用户明确授权后，向第三方机构请求相关信息', '用户自行提供的信息', '依法公开可查的信息渠道']

export default function ServiceSection() {
  return (
    <section className="bg-white py-12">
      <div className="max-w-5xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="sticky top-8">
              <span className="text-xs font-medium text-orange-500 uppercase tracking-wider">关于平台</span>
              <h2 className="text-2xl font-bold text-gray-900 mt-2 mb-4">我们提供什么服务？</h2>
              <p className="text-sm text-gray-600 leading-relaxed">
                优查查是一个个人与企业信息查询平台。在获得用户明确授权的前提下，平台可向第三方机构请求相关信息，并将查询结果进行整理与展示。
              </p>
              <p className="text-xs text-gray-400 mt-4">平台仅承担信息展示职责，信息的理解与使用由用户自行决定。</p>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-gray-50 rounded-2xl p-6">
              <h3 className="text-sm font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <IconArrowRight size={16} className="text-orange-500" />
                信息来源说明
              </h3>
              <ul className="space-y-4">
                {dataSourceItems.map((item, index) => (
                  <li key={index} className="flex items-start gap-3 bg-white rounded-xl p-4">
                    <IconCircleCheck size={20} className="text-orange-500 flex-shrink-0 mt-0.5" />
                    <span className="text-sm text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
              <p className="text-xs text-gray-400 mt-4 pl-1">平台不对信息进行加工判断，仅进行结构化展示。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
